@for (team of tour.teams; track team) {
  <div
    class="drivers-data"
    [class.fixed-assignment]="(tour.state | numericState) >= (fixedAssignmentStatus | numericState)"
    matTooltipPosition="above"
    [matTooltip]="team | driverNames"
    >
    {{ team | driverNames: { onlyAbbreviations: true } }}
  </div>
}
